/**
 * 商户扣款操作
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "会员号",
    "field": "code",
    disabled: true
}, {
    "text": "会员名称",
    "field": "name",
    disabled: true
}, {
    "text": "账户余额",
    "field": "account",
    disabled: true
}, {
    "text": "扣款金额",
    "field": "amount",
    number: true,
    rules: [
        { required: true, message: '扣款金额不能为空!' },
    ]
}, {
    "text": "备注",
    "field": "remark",
    "textarea": true,
    rules: [
        { required: true, message: '备注不能为空!' },
        { max: 128, message: '备注不能超过128个字符！' },
    ]
}];


class MemberDeductionForm extends Component {

    state = {
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            if (values["amount"] > this.props.editData["account"]) {
                messager.notify("扣款金额不能超过账户余额！");
                return;
            }
            let memberCode = this.props.editData.code
            if (memberCode !== undefined && memberCode != null) {
                values["memberCode"] = memberCode;
            }
            http.post({
                url: '/' + this.props.content + '/deductionAccount',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };


    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.number ? <InputNumber min={0} max={99999999} precision={2} style={{ width: '100%' }} />
                                : item.textarea ? <Input.TextArea />
                                    : <Input disabled={item.disabled === true} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="商户扣款"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const MemberDeduction = Form.create()(MemberDeductionForm);

export default MemberDeduction;